import { createI18n } from "vue-i18n";
import enLocale from "./en_GB";
import zhLocale from "./zh_CN";
import { getStoredLang } from "@/utils/lang";

const msg = {
	"en-US": {
		...enLocale,
	},
	"zh-CN": {
		...zhLocale,
	},
	zh_CN: {
		...zhLocale
	}
};

export default createI18n({
	legacy: false,
	globalInjection: true,
	locale: getStoredLang(),
	messages: msg,
});
